// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__tfzF+","widgetTitle":"styles_widgetTitle__08-m9","widgetType":"styles_widgetType__Zck2w"};